import { stringField, optionField, hiddenField } from 'common/utils/form/fieldTypes';

const config = {
  id: hiddenField(),
  name: stringField({ required: true }),
  type_id: optionField({ required: true }),
  value_unit: optionField({ required: true }),
  vessel_type_id: optionField({ required: true }),
  vessel_subtype: optionField(),
  vessel_size: stringField(),
  frequency: optionField(),
  source: stringField(),
  issuer: stringField(),
  values_editable_by: optionField()
};

export default config;
